<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid d-flex flex-row justify-content-between">
      <a class="navbar-brand" href="javascript:void(0)">Lucky Draw Section Management</a>
      <a class="btn btn-sm btn-outline-primary ms-auto" [routerLink]="['/lo', company_uuid, 'draw-section', 'form']">&#43; Add Draw Section</a>
    </div>
  </nav>
  <hr/>
  <div class="card mb-4">
    <div class="card-header">
      <div class="card-title mb-0"><strong>Lucky Draw Turnover Lock</strong></div>
    </div>
    <div class="card-body">
      <form #rulesForm="ngForm" (ngSubmit)="savePromotionRules(rulesForm)" novalidate>
        <div class="form-check form-switch mb-3">
          <input class="form-check-input" type="checkbox" role="switch" id="luckyDrawPromotionEnabled"
                 name="enabled" [(ngModel)]="promotionRules.enabled">
          <label class="form-check-label" for="luckyDrawPromotionEnabled">
            Enable promotion lock for winning Lucky Draw prizes
          </label>
        </div>
        <p class="text-muted small">
          When enabled, a winning prize automatically becomes the player's active promotion. Players with another active promotion cannot receive the prize and their draw chance is preserved.
        </p>
        <div *ngIf="promotionRules.enabled" class="mb-3">
          <label for="luckyDrawPromotion" class="form-label">Promotion</label>
          <ng-select id="luckyDrawPromotion" name="promotion_uuid" [items]="promotions"
                     bindLabel="selection_label" bindValue="uuid" [clearable]="false" [searchable]="true"
                     placeholder="Select Promotion" [(ngModel)]="promotionRules.promotion_uuid"
                     (change)="promotionChanged()" #promotionUuid="ngModel" required>
          </ng-select>
          <div class="text-muted small mt-1">The selected promotion supplies the lock used after a Lucky Draw win.</div>
          <div class="text-danger small" *ngIf="rulesForm.submitted && promotionUuid.invalid">Select a promotion.</div>
        </div>
        <div class="row" *ngIf="promotionRules.enabled">
          <div class="col-md-4 mb-3">
            <label for="luckyDrawTurnover" class="form-label">Turnover (RM)</label>
            <input class="form-control" id="luckyDrawTurnover" name="turnover" type="number" min="0.01" step="0.01"
                   #turnover="ngModel" [(ngModel)]="promotionRules.turnover" required>
            <div class="text-danger small" *ngIf="rulesForm.submitted && turnover.invalid">Enter a turnover greater than 0.</div>
          </div>
          <div class="col-md-4 mb-3">
            <label for="luckyDrawMinimumPayout" class="form-label">Minimum Payout (RM)</label>
            <input class="form-control" id="luckyDrawMinimumPayout" name="minimum_payout" type="number" min="0" step="0.01"
                   #minimumPayout="ngModel" [(ngModel)]="promotionRules.minimum_payout" required>
            <div class="text-danger small" *ngIf="rulesForm.submitted && minimumPayout.invalid">Enter a valid minimum payout.</div>
          </div>
          <div class="col-md-4 mb-3">
            <label for="luckyDrawMaximumPayout" class="form-label">Maximum Payout (RM)</label>
            <input class="form-control" id="luckyDrawMaximumPayout" name="maximum_payout" type="number" min="0" step="0.01"
                   #maximumPayout="ngModel" [(ngModel)]="promotionRules.maximum_payout" required>
            <div class="text-danger small" *ngIf="rulesForm.submitted && maximumPayout.invalid">Enter a valid maximum payout.</div>
          </div>
        </div>
        <button type="submit" class="btn btn-primary" [disabled]="savingRules">
          {{ savingRules ? 'Saving...' : 'Save Lucky Draw Settings' }}
        </button>
      </form>
    </div>
  </div>
  <div class="row">
    <app-tablev2 #table></app-tablev2>
  </div>
